// extracted by mini-css-extract-plugin
module.exports = {"bgDust":"contact_bgDust__16cYu","contactBg":"contact_contactBg__1cnjR"};